import React from "react";
import { Container } from 'react-bootstrap';
import { Outlet } from "react-router-dom";

import Loader from "../components/Loader/Loader";
import { useLoading } from "../context/LoadingContext";

const Content = () => {
    const { loading, updateLoading } = useLoading();
    return (
        <>
            <Container fluid className="content-container d-flex flex-column">
            {loading && <Loader />}
                <Outlet />
            </Container>
        </>
    );
};

export default Content;